function setupRActionTweet() {
  ractionSetup($('#rtweet'));
  $('#rtweet form').submit(function () {
    window.open('http://twitter.com/intent/tweet?text=' + encodeURIComponent($('#rtweet_body').val()), null, 'scrollbars=yes,width=600,height=600,left=150,top=150').focus();
    $.post($(this).attr('action'), $(this).serialize()).done(function (data) {
      nextAction();
    }).fail(function (jqXHR) {
      $('#rtweet').replaceWith(jqXHR.responseText);
    });
    return false;
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = setupRActionTweet;